import { ScheduleState } from "../../../type/schedule-state";

interface Action {
  type: string;
  payload: {
    selectedStatus: string;
  };
}

export const setSelectedStatusDispatch = (
  state: ScheduleState,
  action: Action
) => {
  const { selectedStatus } = action.payload;

  if (state.selectedStatus.includes(selectedStatus)) {
    state.selectedStatus = state.selectedStatus.filter(
      (v) => v !== selectedStatus
    );
  } else {
    state.selectedStatus = [...state.selectedStatus, selectedStatus];
  }
};
